import { Box, Button, Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames'

import PopoverMenu, {
  type PopoverMenuTouchableOptionProps as TouchableOptionComponentProps,
} from 'modules/core/components/PopoverMenu'
import TextField from 'modules/core/components/TextField'
import { FieldArray } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import type { CompanyLinkFormValue } from 'modules/dashboard/widgets/CompanyLinks/forms'

import './index.styles.css'

interface Props {
  item: CompanyLinkFormValue
  index: number
  sortable?: boolean
  popoverOptions: TouchableOptionComponentProps[]
  popoverDisablePortal?: boolean
}

const BoxListInputLinkItem = ({
  item,
  index,
  sortable,
  popoverOptions,
  popoverDisablePortal,
}: Props) => {
  const dragHandle = sortable ? (
    <div className={'BoxListInputLinkItem_dragHandle'}>
      <Icon.Medium icon="drag-and-drop" />
    </div>
  ) : null

  const hasOptions = popoverOptions.length

  return (
    <div
      className={classNames('BoxListInputLinkItem_item', {
        BoxListInputLinkItem_sortable: sortable,
      })}
    >
      {dragHandle}
      <Box gap="s8" style={{ flex: '1' }}>
        <FieldArray name="links">
          {({ replace }) => (
            <>
              <TextField
                type="text"
                placeholder={i18n.t('box_list.fields.link_name.placeholder')}
                value={item.name}
                onChange={(value) => {
                  replace(index, { ...item, name: value })
                }}
              />
              <TextField
                type="text"
                placeholder={i18n.t('box_list.fields.link.placeholder')}
                value={item.url}
                onChange={(value) => {
                  replace(index, { ...item, url: value })
                }}
              />
            </>
          )}
        </FieldArray>
      </Box>
      <div className={'BoxListInputLinkItem_actions'}>
        <PopoverMenu type="list">
          <PopoverMenu.Trigger asChild disabled={!hasOptions}>
            <Button type="secondary" disabled={!hasOptions} iconName="ellipsis" />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="end" disablePortal={popoverDisablePortal}>
            {popoverOptions.map((option) => (
              <PopoverMenu.TouchableOption
                key={option.title}
                title={option.title}
                onClick={option.onClick}
                danger={option.danger}
              />
            ))}
          </PopoverMenu.Content>
        </PopoverMenu>
      </div>
    </div>
  )
}

export default BoxListInputLinkItem
